<template>
  <div class="login-page">
    <div class="login-bg left"></div>
    <div class="login-bg right"></div>
    <div class="login-card">
      <div class="login-icon"><i class="el-icon-lock"></i></div>
      <div class="login-title">域名安全监测平台</div>
      <div class="login-desc">请输入账号和口令登录</div>
      <el-form :model="form" @submit.native.prevent>
        <el-form-item>
          <el-input
            v-model.trim="form.username"
            placeholder="账号"
            prefix-icon="el-icon-user"
            :disabled="loading"
            @keyup.enter.native="doLogin"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="form.password"
            type="password"
            placeholder="口令"
            prefix-icon="el-icon-key"
            show-password
            :disabled="loading"
            @keyup.enter.native="doLogin"
          />
        </el-form-item>
      </el-form>
      <div v-if="errorText" class="login-error">{{ errorText }}</div>
      <el-button type="primary" :loading="loading" class="login-btn" @click="doLogin">登录</el-button>
    </div>
    <footer class="beian-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">鲁ICP备2026032922号-1</a>
      <span>|</span>
      <a class="beian-police-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=37140202001764" rel="noreferrer" target="_blank">
        <img class="beian-police-logo" src="/beian-police.png" alt="公安备案图标" />
        <span>鲁公网安备37140202001764号</span>
      </a>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import {saveDashboardAuth} from "@/utils/dashboardAuth";

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      errorText: "",
      form: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    async doLogin() {
      if (this.loading) {
        return;
      }
      const username = this.form.username.trim();
      const password = this.form.password;

      if (!username || !password) {
        this.errorText = "请输入账号和口令";
        return;
      }

      this.loading = true;
      this.errorText = "";
      try {
        const res = await axios.post("/auth/login", { username, password }, {
          timeout: 10000,
          headers: { "Content-Type": "application/json" }
        });
        const data = res.data || {};

        if (!data.token || !data.expiresAt) {
          throw new Error("empty token");
        }
        saveDashboardAuth({ token: data.token, username: data.username || username, expiresAt: data.expiresAt });
        const redirect = this.$route.query && this.$route.query.redirect ? String(this.$route.query.redirect) : "/entitylink";

        this.$router.replace(redirect);
      } catch (err) {
        const response = err && err.response;
        const code = response && response.data && response.data.code;

        if (code === "DASHBOARD_AUTH_NOT_CONFIGURED") {
          this.errorText = "登录账号尚未配置，请联系管理员";
        } else if (response && response.status === 429) {
          this.errorText = "登录尝试过多，请稍后再试";
        } else {
          this.errorText = "账号或口令错误";
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
.login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: radial-gradient(circle at top, #113060 0%, #06152d 45%, #020814 100%);
  color: #fff;
}

.login-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 240px;
  opacity: .55;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  &.left {
    left: 0;
    background-image: url("~@assets/leftSider.png");
  }

  &.right {
    right: 0;
    background-image: url("~@assets/rightSider.png");
  }
}

.login-card {
  position: relative;
  z-index: 1;
  width: 420px;
  padding: 42px 42px 36px;
  border: 1px solid rgba(68, 144, 255, .45);
  border-radius: 12px;
  background: rgba(5, 22, 49, .86);
  box-shadow: 0 18px 60px rgba(0, 0, 0, .42), inset 0 0 30px rgba(30, 116, 255, .16);
  text-align: center;
}

.login-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 18px;
  line-height: 64px;
  border-radius: 50%;
  color: #8fc7ff;
  font-size: 34px;
  background: rgba(31, 112, 255, .16);
  border: 1px solid rgba(123, 190, 255, .35);
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #e9f5ff;
}

.login-desc {
  margin: 10px 0 28px;
  color: #8aa9d6;
  font-size: 14px;
}

.login-error {
  min-height: 20px;
  margin: -4px 0 12px;
  color: #ff8b8b;
  font-size: 13px;
  text-align: left;
}

.login-btn {
  width: 100%;
  height: 42px;
  font-size: 16px;
}

.beian-footer {
  position: absolute;
  left: 24px;
  right: 24px;
  bottom: 20px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
  color: rgba(196, 214, 239, .78);
  font-size: 13px;
}

.beian-footer a {
  color: rgba(196, 214, 239, .78);
  text-decoration: none;
}

.beian-footer a:hover {
  color: #8fc7ff;
}

.beian-police-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.beian-police-logo {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

/deep/ .el-input__inner {
  height: 42px;
  color: #eaf4ff;
  background: rgba(3, 18, 42, .72);
  border-color: rgba(98, 154, 235, .35);
}

/deep/ .el-input__inner:focus {
  border-color: #4d9dff;
}

@media (max-width: 768px) {
  .login-card {
    width: calc(100% - 40px);
    padding: 32px 24px;
  }

  .login-bg {
    display: none;
  }
}
</style>
